module.exports = __webpack_public_path__ + "img/madera017.ce458851.jpg";